import { PersonaFisicaDTO } from "./persona-fisica-dto";

export class AltriSoggettiGiudiziarioDTO {
	soggettoNonIdentificato: Boolean;
	idPersona: string;
	cognome: string;
	nome:	string;
	codFiscale:  string;
	comuneNascita: string;
	provinciaNascita: string;
	dataNascita: Date;
	personaFisica: PersonaFisicaDTO;
}
